import * as angular from 'angular';

import { ComponentDefinition, Group, WorkflowActionDTO, ActionType, Dictionary } from '../../../models';

class WorkflowActionCell implements angular.IComponentController {
    content: string;
    dto: WorkflowActionDTO;
    group: Group;
    groups: Dictionary<Group>;
    hasLink: boolean;
    isDisabled: boolean;
    isMail: boolean;
    isOnline: boolean;
    isTask: boolean;

    readonly isLocked: boolean;

    static $inject = [];

    $onInit() {
        this.refresh();
    }

    $onChanges(_changes: angular.IOnChangesObject) {
        this.refresh();
    }

    refresh() {
        const group = this.groups[this.dto.groupGuid];
        let content: string;
        let hasLink = false, isOnline = false, isTask = false, isMail = false, isDisabled = false;

        if (this.dto) {
            content = this.dto.subject;
            isDisabled = this.dto.isDisabled;

            switch (this.dto.type) {
                case ActionType.OnlineJobs:
                    isOnline = true;
                    break;
                case ActionType.ReprocessingTask:
                    isTask = true;
                    break;
                case ActionType.SendMail:
                    hasLink = true;
                    isMail = true;
                    break;
                case ActionType.Email:
                    isMail = true;
                    break;
                default:
                    console.warn(`Unknown action type from workflow ${this.dto.guid}`);
                    break;
            }
        }

        this.hasLink = hasLink;
        this.isDisabled = isDisabled;
        this.isOnline = isOnline;
        this.isMail = isMail;
        this.isTask = isTask;
        this.content = content;
        this.group = group;
    }
}

export const wtWorkflowActionCell: ComponentDefinition = {
    componentId: 'wtWorkflowActionCell',
    controller: WorkflowActionCell,
    template: require('./workflowActionCell.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLocked: '<?',
        dto: '<',
        groups: '<',
    }
};